<template>
  <div class="newsBulletin app-content">
    <div class="head-box">
      <span>当前位置： </span>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item><a href="/">新闻公告</a></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="news-content">
      <div class="left-content">
        <news-list :newsList="newsList"></news-list>
<!--        <div class="title-box">-->
<!--          <h2>山西技通天下在线学习平台公告</h2>-->
<!--          <div class="titleII">2020.8.1发布     技通天下发布</div>-->
<!--        </div>-->
<!--        <div class="content">-->
<!--             <p>为响应山西省职业技能线上培训工作，推动“人人持证、技 能社会”建设，创新职业技能培训方式，提高信息化水平，提供 便捷高效的培训平台，助力全民技能提升培训。山西技通天下在线学习平台特推出各个技能工种，供广大学员在线学习。-->
<!--          在线工种课程学习注册流程及学习课程质量控制</p>-->
<!--          <p>  1 注册：登陆平台进行基本信息的注册，手机注册后平台会发送短信验证码，予以验证。</p>-->
<!--          <p>  2 实名认证：在学习技能工种课程前，要求进行实名认证，必须上传自己真实有效的身份证和人脸拍照登记，以便日后学习中进行检测验证。</p>-->
<!--          <p>  3 选择工种：每个技能工种课程可以试看1分钟，确认开始学习该技能工种课程后，可以观看所有课程，但不能同时开设另外的技能工种课程。</p>-->
<!--          <p>  4 学习视频：技能工种课程下的课程视频，按步骤进行观看，观看不可以进行快进，播放控制下的快进、快退只对本集观看过的进度起作用。</p>-->
<!--          <p>  5 答题测试：采用随学随测的答题模式，即观看每集课程视频后进行5道答题，每个技能工种课程有3个阶段性答题测试，必须观看到指定集数后才可阶段测试。</p>-->
<!--          <p>  6 领证：学习完每个技能工种课程下的所有视频，以及答题测试通过后，才可以领取培训合作证书。</p>-->
<!--        </div>-->
<!--        <div class="foot">最终解释权:山西大数据产业发展有限公司</div>-->
      </div>
      <ul class="right-content">
        <li class="title">热门推荐</li>
        <li class="list-item"><router-link to='#'>我付出，我收获，我幸福</router-link></li>
        <li class="list-item"><router-link to='#'>学习雷锋好榜样，爱岗敬...</router-link></li>
        <li class="list-item"><router-link to='#'>用户放心，我开心！</router-link></li>
        <li class="list-item"><router-link to='#'>阳光到家，责任到家</router-link></li>
        <li class="list-item"><router-link to='#'>真心付出，信任无价</router-link></li>
      </ul>
    </div>
  </div>
</template>

<script>
import newsList from '../components/newsList'
// import axios from 'axios'
const newsList11 = require('../../mock/newsList.json')
export default {
  name: 'newsBulletin',
  components: {
    newsList
  },
  data () {
    return {
      newsList: newsList11.data
    }
  },
  mounted () {
    // this.getData()
  },
  methods: {
    // // 获取学科数据
    // getData () {
    //   let that = this
    //   axios({
    //     method: 'get',
    //     url: '/th/newsList'
    //   }).then((result) => {
    //     that.newsList = result.data.data.data
    //   })
    // }
  }
}
</script>

<style lang="scss" scoped>
.newsBulletin{
  width: 1200px;
  margin: 0 auto 20px;
  .news-content{
    display: flex;
    .left-content{
      width: 920px;
      padding: 40px;
      box-shadow:1px 2px 4px 1px #ccc;
      margin-right: 40px;
      .title-box{
        text-align: center;
        .titleII{
          margin: 20px 0px 30px;
          line-height: 50px;
        }
      }
      .content{
        font-size: 14px;
        line-height: 30px;
      }
      .foot{
        text-align: right;
        margin-top: 45px;
      }
    }
    .right-content{
      width: 240px;
      max-height: 300px;
      padding: 20px;
      box-shadow:1px 2px 4px 1px #ccc;
      .title{
        width: 100%;
        font-size: 20px;
        text-align: center;
        color: #ce443a;
        padding-bottom: 20px;
      }
      .list-item{
        line-height: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/newsBulletin.vue